
<mat-icon class="opacity-75">search</mat-icon>
<input #input [placeholder]="'ss-general.search' | translate" class="border-style-none flex-1" matInput [value]="searchSubject | async"/>

<div class="full-height border-gray-left padding-small-left" *ngIf="input.value">
    <button 
        stopPropagation 
        (click)="input.value='';searchSubject.next('')" 
        class="opacity-75 small-icon-button" 
        mat-icon-button
    >
        <mat-icon>close</mat-icon>
    </button>
</div>


